export default "__VITE_ASSET__BkkOzYNf__"